import type { ButtonHTMLAttributes, ReactNode, Ref } from "react";
import { cx } from "../../lib/cx";
import styles from "./Button.module.css";

export type ButtonVariant = "primary" | "secondary" | "outline" | "ghost" | "destructive";
export type ButtonSize = "sm" | "md";

export type ButtonProps = {
  variant?: ButtonVariant;
  size?: ButtonSize;
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
  ref?: Ref<HTMLButtonElement>;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: "btn btn-primary",
  secondary: "btn btn-secondary",
  outline: "btn btn-outline-primary",
  ghost: "btn btn-shobdo-ghost",
  destructive: "btn btn-shobdo-destructive",
};

export const Button = ({
  variant = "primary",
  size = "md",
  leadingIcon,
  trailingIcon,
  className,
  children,
  ref,
  ...rest
}: ButtonProps) => (
  <button
    ref={ref}
    type="button"
    data-variant={variant}
    data-size={size}
    className={cx(VARIANT_CLASS[variant], size === "sm" && "btn-sm", className)}
    {...rest}
  >
    {leadingIcon && <span className={styles.icon}>{leadingIcon}</span>}
    <span className={styles.label}>{children}</span>
    {trailingIcon && <span className={styles.icon}>{trailingIcon}</span>}
  </button>
);
